@if (carregando()) {
    <div class="p-6 text-center">Carregando roles do Keycloak…</div>
} @else if (erro()) {
    <div class="p-4 text-red-600">Não foi possível carregar as roles do Keycloak (/api/roles).</div>
} @else if (resultado(); as res) {
    <div class="flex flex-wrap gap-2 mb-4">
        <p-tag severity="success" [value]="'Em sincronia: ' + res.contadores.sincronia" />
        <p-tag severity="warn" [value]="'Órfãs no Keycloak: ' + res.contadores.orfas" />
        <p-tag severity="info" [value]="'Faltando no Keycloak: ' + res.contadores.faltando" />
        @if (res.contadores.foraPadrao > 0) {
            <p-tag severity="danger" [value]="'Fora do padrão: ' + res.contadores.foraPadrao" />
        }
        @if (res.contadores.acesso > 0) {
            <p-tag severity="secondary" [value]="'Acesso/Sistema: ' + res.contadores.acesso" />
        }
    </div>

    @for (mod of grupos(); track mod.modulo) {
        <div class="border rounded p-3 mb-3">
            <div class="font-bold mb-2">{{ mod.moduloLabel }} ({{ mod.total }})</div>
            @for (func of mod.funcionalidades; track func.funcionalidade) {
                <div class="mb-2">
                    <div class="font-semibold mb-1">{{ func.funcionalidadeLabel }}</div>
                    @for (ac of func.todas; track ac.role) {
                        <div class="flex items-center gap-2">
                            @if (ehOrfa(ac.role)) {
                                <p-tag severity="warn" value="órfã" />
                            } @else {
                                <p-tag severity="success" value="✓" />
                            }
                            <span>{{ ac.role }}</span>
                        </div>
                    }
                </div>
            }
        </div>
    }

    @if (res.faltando.length) {
        <div class="border rounded p-3 mb-3">
            <div class="font-bold mb-2">Faltando no Keycloak ({{ res.faltando.length }})</div>
            <ul class="m-0 pl-4">
                @for (r of res.faltando; track r) {
                    <li>{{ r }}</li>
                }
            </ul>
        </div>
    }
    @if (res.foraPadrao.length) {
        <div class="border rounded p-3 mb-3">
            <div class="font-bold mb-2">Fora do padrão ({{ res.foraPadrao.length }})</div>
            <ul class="m-0 pl-4">
                @for (r of res.foraPadrao; track r) {
                    <li>{{ r }}</li>
                }
            </ul>
        </div>
    }
}
